import React, { useRef, useState } from "react";
import AccountShell, { PasswordField } from "./AccountShell";
import { accountRequest } from "./accountApi";

export default function ChangePassword() {
  return <AccountShell title="Change Password"><ChangePasswordForm /></AccountShell>;
}
function ChangePasswordForm() {
  const [current, setCurrent] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const submitting = useRef(false);
  async function submit(event) {
    event.preventDefault();
    if (submitting.current) return;
    setError(""); setMessage("");
    if (password !== confirm) { setError("New passwords do not match."); return; }
    if (new TextEncoder().encode(password).length > 72) { setError("Your new password must not exceed 72 UTF-8 bytes."); return; }
    submitting.current = true; setBusy(true);
    try {
      const data = await accountRequest("change-password", {
        current_password: current, password, confirm_password: confirm,
      });
      setCurrent(""); setPassword(""); setConfirm(""); setMessage(data.message);
      try { localStorage.removeItem("ltc-remembered-password"); } catch { /* Optional storage. */ }
    } catch (error) { setError(error.message); }
    finally { submitting.current = false; setBusy(false); }
  }
  return <form onSubmit={submit}>
    <p className="ltc-member-intro">Enter your current password, then choose a new password.</p>
    {error && <p className="ltc-member-error" role="alert">{error}</p>}
    {message && <p className="ltc-member-success" role="status">{message}</p>}
    <fieldset className="ltc-member-fields" disabled={busy}>
      <PasswordField id="member-current" label="Current Password" autoComplete="current-password" maxLength={4096}
        value={current} onChange={(event) => setCurrent(event.target.value)} />
      <PasswordField id="member-new" label="New Password" value={password} onChange={(event) => setPassword(event.target.value)} />
      <PasswordField id="member-confirm" label="Confirm New Password" value={confirm} onChange={(event) => setConfirm(event.target.value)} />
      <button className="ltc-member-submit" type="submit">{busy ? "Updating…" : "Update Password"}</button>
    </fieldset>
  </form>;
}
